import script from "./RecentPost.vue?vue&type=script&setup=true&lang=js"
export * from "./RecentPost.vue?vue&type=script&setup=true&lang=js"

import "./RecentPost.vue?vue&type=style&index=0&id=5665a440&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5665a440"]])

export default __exports__